import { Flex } from 'antd';
import { useTranslation } from 'react-i18next';
import { fontSize, spacing } from '../../theming';
import { mutedSmallStyle } from './vinExtractionStyles';

const CarDrawerHeader = ({ car, failedNav }) => {
    const { t } = useTranslation('vinExtraction');

    return (
        <Flex justify="space-between" align="baseline" gap={spacing[2]} wrap="wrap">
            <span>{t('drawer.title', { id: car.carId })}</span>
            {/* E22: "k of N failed" only when the drawer walks the Failed tab */}
            {failedNav && (
                <span style={{ ...mutedSmallStyle, fontSize: fontSize.xs }}>
                    {t('drawer.position', { position: failedNav.position, total: failedNav.total })}
                </span>
            )}
        </Flex>
    );
};

export default CarDrawerHeader;
